import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { includes } from 'lodash';

import Header from './Header';
import Subheader from './Subheader';
import Loader from '../components/Loader';
import StateStore from '../globalStates/Store';
import useContextService from '../hooks/useContextService';
import AppStore from '../context';
import Footer from './Footer';

const Next = () => {
  const { states, resetStates } = useContextService();
  const { loading } = states;
  return (
    <>
      {loading && <Loader opacity={0.01} color='black' />}
      <Outlet />
    </>
  );
};

const Layout = (props) => {
  const { modules } = props;
  return (
    <AppStore>
      <StateStore>
        <section>
          <Header />
          <Subheader modules={modules} />
          <div className='content-wrapper bg-white'>
            <Next />
             <Footer/>
          </div>
        </section>
      </StateStore>
    </AppStore>
  );
};

export default Layout;
